import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-subcategory-modal',
  templateUrl: './product-subcategory-modal.component.html',
  styleUrls: ['./product-subcategory-modal.component.scss']
})
export class ProductSubcategoryModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  saveProductSubcategoryModal(){
    
  }

  closeModal(){

  }

}
